export const retrieveUrlQueryParams = (url: string) => {
  const fragmentIdentifier = url.split('?')[1];
  const data = new URLSearchParams(fragmentIdentifier);
  return Object.fromEntries(data as unknown as Map<string, string>);
};
